import { StandardQuizQuestion } from '@/types/quizTypes';

export const IOT_SECURITY_QUIZ: StandardQuizQuestion[] = [
  {
    id: "iot-sec-1",
    question: "What is the biggest security challenge in IoT devices?",
    options: [
      "High computational power",
      "Limited resources making traditional security difficult to implement",
      "Too much encryption",
      "Fast update cycles"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "IoT devices often have limited CPU, memory, and power, making it challenging to implement robust security measures like strong encryption and frequent security updates.",
    category: "security-challenges",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "iot-sec-2",
    question: "What is a common authentication method for IoT devices?",
    options: [
      "Username and password only",
      "X.509 certificates and mutual TLS",
      "No authentication needed",
      "Social media login"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "X.509 certificates with mutual TLS provide strong device authentication. Each device has a unique certificate to prove identity, and the server also authenticates to the device.",
    category: "authentication",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "iot-sec-3",
    question: "What is a hardware root of trust in IoT?",
    options: [
      "Cloud storage backup",
      "Secure hardware element that stores cryptographic keys",
      "Network firewall",
      "Antivirus software"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "A hardware root of trust (like TPM or secure element) is tamper-resistant hardware that securely stores cryptographic keys and performs security operations, providing a foundation for device security.",
    category: "hardware-security",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "iot-sec-4",
    question: "What does end-to-end encryption mean in IoT?",
    options: [
      "Only encrypting stored data",
      "Data is encrypted from device to cloud and only decrypted at endpoints",
      "Encrypting network cables",
      "Password protecting devices"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "End-to-end encryption ensures data is encrypted on the device, remains encrypted in transit, and is only decrypted by the intended recipient, protecting against interception.",
    category: "encryption",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "iot-sec-5",
    question: "What is firmware signing?",
    options: [
      "Writing comments in code",
      "Cryptographically signing firmware to verify authenticity and integrity",
      "Naming firmware versions",
      "Compressing firmware files"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Firmware signing uses digital signatures to ensure firmware is authentic (from trusted source) and hasn't been tampered with, preventing malicious firmware installation.",
    category: "secure-boot",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "iot-sec-6",
    question: "What is a botnet in IoT context?",
    options: [
      "A helpful automation tool",
      "A network of compromised IoT devices controlled by attackers",
      "A cloud service",
      "A monitoring dashboard"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "An IoT botnet is a network of infected devices hijacked by attackers to perform DDoS attacks or other malicious activities. Mirai is a famous example that infected millions of devices.",
    category: "threats",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "iot-sec-7",
    question: "What is secure provisioning?",
    options: [
      "Fast device setup",
      "Securely installing credentials and keys during device manufacturing",
      "Cloud migration",
      "Device testing"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Secure provisioning involves safely injecting unique credentials, certificates, and keys into devices during manufacturing in a secure environment, establishing device identity.",
    category: "device-lifecycle",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "iot-sec-8",
    question: "Why is network segmentation important for IoT?",
    options: [
      "Increases bandwidth",
      "Isolates IoT devices from critical systems to limit attack surface",
      "Makes devices faster",
      "Reduces costs"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Network segmentation separates IoT devices into isolated network zones, preventing compromised IoT devices from accessing critical enterprise systems or sensitive data.",
    category: "network-security",
    points: 10,
    type: "multiple-choice"
  }
];

export const generateIotSecurityQuiz = () => ({
  questions: IOT_SECURITY_QUIZ,
  passThreshold: 75,
  timeLimit: 900,
  category: 'iot-security'
});
